import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {UmpireIncident} from '@tisa-group/models';

@Injectable()
export class IncidentService implements CrudService<UmpireIncident> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireIncident>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireIncident>> {
    return this.http
      .post<JsonApiResponse<UmpireIncident>>('/incidents', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireIncident>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireIncident>> {
    return this.http
      .patch<JsonApiResponse<UmpireIncident>>(
        `/incidents/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/incidents/${id}`);
  }
}
